<template>
  <div class="card">
    <div class="card-header ps-7 pe-5">
      <h3 class="card-title align-items-start flex-column">
        {{ translate("checklist_template_component_title") }}
        <span class="text-muted mt-1 fw-bold fs-7"
          >{{ records }} {{ translate("Records_Found") }}</span
        >
      </h3>
    </div>
    <div
      v-if="checklists.length == 0 && !isListEmpty"
      class="h-550px d-flex justify-content-center align-items-center"
    >
      <span class="fs-6">{{
        translate("checklist_template_not_template")
      }}</span>
    </div>
    <div v-else class="p-5">
      <div>
        <div class="card-toolbar mb-5">
          <div class="d-flex justify-content-end align-items-center">
            <div>
              <!-- <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="router.push({ name: 'new-checklist' })"
              >
                {{ translate("checklist_component_button_add_checklist") }}
              </button> -->
              <button
                v-show="selectedChecklist.length > 0"
                @click="deleteChecklist($event)"
                type="button"
                class="btn bg-light bg-hover-secondary btn-sm border position-relative ms-2"
              >
                {{ translate("Delete_Select")
                }}<span
                  class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
                  >{{ selectedChecklist.length }}</span
                >
              </button>
            </div>
          </div>
        </div>
      </div>

      <DataTable
        :value="checklists"
        dataKey="Id"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        v-model:filters="filters"
        filterDisplay="row"
        :globalFilterFields="['title']"
        :lazy="true"
        :paginator="false"
        :loading="loading"
        :totalRecords="totalRecords"
        removableSort
        class="rounded"
        responsiveLayout="scroll"
      >
        <Column headerStyle="width: 3em"></Column>
        <Column
          field="ChecklistName"
          :header="translate('checklist_template_component_column_title')"
          filterField="checklistName"
          filterMatchMode="contains"
          ref="checklistName"
          :sortable="true"
          style="width: 35rem !important; min-width: 35rem !important"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              name="checklistName"
              type="text"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              :placeholder="translate('Search')"
              @keyup="inputNull($event)"
            />
          </template>
        </Column>

        <Column field="Id" :rowEditor="true" bodyStyle="text-align:center">
          <template #body="{ data }">
            <div class="d-flex justify-content-end">
              <a
                class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                :title="translate('checklist_template_component_a_title')"
                @click="copyChecklist(data.Id, $event)"
              >
                <div :id="`spinner-${data.Id}`"></div>

                <span :id="`icon-${data.Id}`" class="svg-icon svg-icon-3">
                  <inline-svg src="media/icons/duotune/general/gen054.svg" />
                </span>
              </a>

              <!-- <router-link
                class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                :title="translate('Update')"
                :to="`/checklists/edit-checklist/${data.Id}`"
              >
                <span class="svg-icon svg-icon-3">
                  <inline-svg src="media/icons/duotune/art/art005.svg" />
                </span>
              </router-link>

              <a
                class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                :title="translate('Delete')"
                @click="deleteChecklist($event, data)"
              >
                <span class="svg-icon svg-icon-3">
                  <inline-svg src="media/icons/duotune/general/gen027.svg" />
                </span>
              </a> -->
            </div>
          </template>
        </Column>
      </DataTable>
      <ConfirmPopup></ConfirmPopup>
      <div class="mt-5">
        <Pagination @onPage="onPage" :TotalData="records" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useConfirm } from "primevue/useconfirm";

//Store Tanımlaması
const store = useStore();
const confirm = useConfirm();

const block = ref(true);
const loadingSpinner = ref(false);
//Router Tanımlaması
const router = useRouter();

// Multi Language
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const copyChecklist = (Id, event) => {
  confirm.require({
    target: event.currentTarget,
    message: translate("checklist_template_confirm_copy"),
    icon: "pi pi-exclamation-triangle",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      const element = document.getElementById(`spinner-${Id}`);
      element.classList.add("spinner-border", "spinner-border-sm");

      const icon = document.getElementById(`icon-${Id}`);
      icon.style.display = "none";

      store
        .dispatch("AdminTemplateCheckListModule/CHECKLIST_NEW_CREATE", Id)
        .then((response) => {
          element.classList.remove("spinner-border", "spinner-border-sm");
          icon.style.display = "block";
          if (response) {
            router.push(`/checklists/edit-checklist/${response.id}`);
            loadingSpinner.value = false;
          }
        });
    },
    reject: () => {
      return;
    },
  });
};

const checklists = computed(
  () => store.getters["AdminTemplateCheckListModule/_getCompanyCheckTemp"]
);
const records = computed(
  () => store.getters["AdminTemplateCheckListModule/_getCompanyTempTotal"]
);
let selectedChecklist = ref([]);
const selectAll = ref(false);
const totalRecords = ref(0);
const lazyParams = ref({});
const loading = ref(true);
const isListEmpty = ref(false);
lazyParams.value = {
  page: 1,
  pageSize: 10,
  sortColumn: null,
  sortDirection: null,
  companyId: 0,
  checklistName: null,
};
//Data Table Filter Tanımlaması
const filters = ref({
  checklistName: { value: null, matchMode: "contains" },
});

// Data Table Eventları
const onPage = (e) => {
  lazyParams.value.page = e.step.value;
  lazyParams.value.pageSize = e.pageSize.value;
  getChecklists(lazyParams.value);
};

const onSort = (event) => {
  lazyParams.value.sortColumn = event.sortField;
  lazyParams.value.sortDirection = event.sortOrder === 1 ? "asc" : "desc";
  getChecklists(lazyParams.value);
};

const onFilter = () => {
  lazyParams.value.checklistName = filters.value.checklistName.value;
  getChecklists(lazyParams.value);
  isListEmpty.value = true;
};

const onSelectAllChange = (event) => {
  if (event.checked) {
    selectAll.value = true;
    selectedChecklist.value = checklists.value;
  } else {
    selectAll.value = false;
    selectedChecklist.value = [];
  }
};

const onRowSelect = () => {
  selectAll.value = selectedChecklist.value.length === totalRecords.value;
};

const onRowUnselect = () => {
  selectAll.value = false;
};

const inputNull = (event) => {
  if (event.target.value === "") {
    lazyParams.value[event.target.name] = "";
    getChecklists(lazyParams.value);
  }
};

// CheckList Delete İşlemi
const deleteChecklist = (event, Item) => {
  let obj = [];
  let list = [];
  if (Item !== undefined) {
    obj.push(Item.Id);
    list.push(obj);
    list.push(lazyParams.value);
  } else {
    selectedChecklist.value.forEach((item) => {
      obj.push(item.Id);
    });
    list.push(obj);
    list.push(lazyParams.value);
  }
  let message = ref("");
  if (obj.length > 1) {
    message.value = translate("confirm_message_checklists");
  } else {
    message.value = translate("confirm_message_checklist");
  }
  confirm.require({
    target: event.currentTarget,
    message: message.value,
    icon: "pi pi-exclamation-triangle",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      store
        .dispatch("CheckListModule/DELETE_CHECKLIST", list)
        .finally((selectedChecklist.value = []));
    },
    reject: () => {
      return;
    },
  });
};

//Data Çekme
const getChecklists = () => {
  lazyParams.value.companyId = companyId;
  store
    .dispatch(
      "AdminTemplateCheckListModule/GET_COMPANY_TEMP_CHECKLIST",
      lazyParams.value
    )
    .finally(() => {
      loading.value = false;
    });
  // .finally(() => (block.value = false));
};

const companyId = store.state.AuthModule.User.CompanyId;

watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("Menu_Templates"), []);
});

onMounted(() => {
  setCurrentPageBreadcrumbs(translate("Menu_Templates"), []);
});

getChecklists({
  page: 1,
  pageSize: 10,
});
</script>
